import { useMutation, useQueryClient } from '@tanstack/react-query';
import { preferencesKeys } from '../query-keys';
import { patchBoardPreference } from '../requests';
import type {
  GetPreferenceResponse,
  PatchBoardPreferenceRequest,
} from '../types';

export const usePatchBoardPreference = <
  T extends Record<string, unknown>,
>() => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: PatchBoardPreferenceRequest<T>) =>
      patchBoardPreference<T>(params),
    onSuccess: (response, variables) => {
      queryClient.setQueryData<GetPreferenceResponse<T>>(
        preferencesKeys.key(variables.boardId, variables.key),
        response,
      );
    },
  });
};
